if (!customElements.get('cs-carousel')) {
  class CsCarousel extends HTMLElement {
    constructor() {
      super();
      this.current = 0;
      this.autoplay = false;
      this.timer = null;
    }

    connectedCallback() {
      this.root = this.closest('.cs, .ps') || this;
      this.track = this.querySelector('.cs__carousel-track');
      this.slides = this.querySelectorAll('.cs__carousel-slide');
      this.prevBtn = this.querySelector('[data-cs-prev]');
      this.nextBtn = this.querySelector('[data-cs-next]');
      this.autoplay = this.dataset.autoplay === 'true';

      var groupKeysScript = this.root.querySelector('[data-cs-group-keys]');
      this.groupKeys = [];
      if (groupKeysScript) {
        try { this.groupKeys = JSON.parse(groupKeysScript.textContent) || []; } catch (e) {}
      }

      // A mount can opt into its own per-slide group-key array (rather than
      // the shared one above) via <script data-cs-group-keys-for="{slot}">,
      // for cases where that mount's grouping rule genuinely differs from
      // every other mount's (e.g. the sticky-cart product list groups by
      // type+series only, while the colour-variant thumbnails group Shields
      // by shield_series too and merge T-Shirt/Hat into one row).
      this.mountGroupKeys = {};
      this.root.querySelectorAll('[data-cs-group-keys-for]').forEach((script) => {
        var slot = script.dataset.csGroupKeysFor;
        try { this.mountGroupKeys[slot] = JSON.parse(script.textContent) || []; } catch (e) {}
      });

      if (!this.track || this.slides.length <= 1) return;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

      // Delegated (not per-button) so thumbnail buttons that arrive later via
      // a template clone (see update()) are handled without re-attaching
      // listeners to each newly-cloned button.
      this.root.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-cs-slide]');
        if (!btn || !this.root.contains(btn)) return;
        const idx = parseInt(btn.dataset.csSlide, 10);
        if (!isNaN(idx)) this.goTo(idx);
      });

      let startX = 0;
      this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) diff > 0 ? this.next() : this.prev();
      });

      if (this.autoplay) this.start();
    }

    goTo(index) {
      if (index < 0 || index >= this.slides.length) return;
      this.current = index;
      this.update();
      if (this.autoplay) this.reset();
    }

    next() {
      this.current = this.current + 1 >= this.slides.length ? 0 : this.current + 1;
      this.update();
      if (this.autoplay) this.reset();
    }

    prev() {
      this.current = this.current - 1 < 0 ? this.slides.length - 1 : this.current - 1;
      this.update();
      if (this.autoplay) this.reset();
    }

    update() {
      this.track.style.transform = 'translateX(-' + this.current * 100 + '%)';

      // Each mount holds exactly one product's content at a time, cloned in
      // from the matching inert <template> — never more than one panel's
      // worth of markup live in the DOM simultaneously. Panel-keyed slots
      // (one template per product) are tried first; slots that only exist
      // grouped (e.g. variant-thumbnail rows shared by every product in the
      // same series) fall back to a group-keyed template instead.
      const groupKey = this.groupKeys[this.current];
      this.root.querySelectorAll('[data-cs-mount]').forEach((mount) => {
        const slot = mount.dataset.csMount;
        const slotGroupKeys = this.mountGroupKeys[slot];
        const effectiveGroupKey = slotGroupKeys ? slotGroupKeys[this.current] : groupKey;
        let tpl = this.root.querySelector('template[data-cs-slot="' + slot + '"][data-cs-panel="' + this.current + '"]');
        if (!tpl && effectiveGroupKey) {
          tpl = this.root.querySelector('template[data-cs-slot="' + slot + '"][data-cs-group="' + effectiveGroupKey + '"]');
        }
        if (tpl) {
          mount.replaceChildren(tpl.content.cloneNode(true));
        } else {
          mount.replaceChildren();
        }
      });

      this.root.querySelectorAll('[data-cs-slide]').forEach((btn) => {
        const idx = parseInt(btn.dataset.csSlide, 10);
        btn.classList.toggle('cs__variant-btn--active', idx === this.current);
      });
    }

    start() { this.timer = setInterval(() => this.next(), 4000); }
    reset() { clearInterval(this.timer); this.start(); }

    disconnectedCallback() { clearInterval(this.timer); }
  }

  customElements.define('cs-carousel', CsCarousel);
}
